import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { TeamRestService } from "@app/services/hal/team-rest.service";
import { Team } from "@app/models/rest/team";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class TeamStore extends RealTimeDataStore<Team> {
  constructor() {
    const teamRestService = inject(TeamRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(teamRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("Team");
  }
}
